import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import React from 'react';

export const Input = (
  <>
    <AddCircleOutlineIcon />
    Upload videos
  </>
);
